import React from 'react';
  import axios2 from 'services/axios2';
  import moment from "moment";

  import {useParams, Link,hashHistory} from 'react-router-dom';
  import { ToastContainer, toast } from 'react-toastify';
  import NuSpinner  from 'components/nubox/NuSpinner';
  import ImageUploadSingle from 'components/nubox/ImageUploadSingle';

  //import listac from '../assets/img/lista2.png';
  import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
    ToastHeader,
  } from 'reactstrap';

  const formInitial = {
    idd:0,
    ope:'n',

    tam:0,
    id_est:0,
    nomape_tmp:'',
    
  };
  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  class ModalSorteo extends React.Component {
    state = {
      modalInsertar:false,
      modalSorteo:false,
      
      isSortOut:false,

      form: formInitial,
      
      dataList:[], /* lista de estudiantes */
    };
    //------------------------------------------------------
    componentDidMount() {
      console.log('componentDidMount Modal');
      //--limpiamos el array de prueba
      
      
      //this.cargar_grupos();
      //const date = moment();
      //const formattedDate = date.format('YYYY-MM-DD');
      
      //console.log(formattedDate);
      //---------
      this.limpiar();
    }
    //-------------------
    limpiar = () =>{
      const date = moment();
      const dateNow = date.format('YYYY-MM-DD');

      formInitial.fecha = dateNow
      this.setState({form: formInitial });
    }
    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    };
    //======================================================
    showModal = () => {
      //setModalOpen(true);
      this.setState({ modalInsertar: true});
    }
    closeModal = () => {
      //setModalOpen(true);
      this.setState({ modalInsertar: false});
    }
    //---------------
    nuevo =(lista) =>{
      console.log('nuevo');
      //this.limpiar();
      //let materia = this.props.store.materia
      //let user = this.props.store.user
      //formInitial.id_mate = id_mate
      //formInitial.id_peri = id_peri
      
      //----------------------------------------
      /*this.setState({
        form: {
          ...formInitial,
          idd: 0,
          ope:'n'
        },
        modalInsertar: true,
      });
      */
     this.setState({ dataList: lista,
        modalInsertar:true,
     })
    }
    //---------------
    
    //----------------------------------------------------------------
    sortear_click=(e)=>{
      e.preventDefault()
      this.setState({ isSortOut: true }); 
      //llamamos al sorteo despues de 2 segundos 
      setTimeout(() => {
        //console.log("¡Han pasado 2 segundos!");
        this.sortear()
      }, 1000); // 2000 ms = 2 segundos
    }
    //------------------------------------------------------------------
    sortear=()=>{
      //---procedemos al sorteo
      //--de la lista de los participantes, escogemos uno aleatoriamente
      let min=0
      let max= this.state.dataList.length-1
      let pos = this.getRandomInt(min,max) 
      console.log(pos)
      console.log(this.state.dataList[pos])

      //--- obtenemos el row asociado al numero
      let ap_pat = this.state.dataList[pos].ap_pat
      let ap_mat = this.state.dataList[pos].ap_mat
      let nombres = this.state.dataList[pos].nombres

      let nomape_tmp = ap_pat + ' '+ ap_mat + ', ' + nombres
      this.setState({
                form: {
                  ...this.state.form,
                  'nomape_tmp': nomape_tmp,
                },
                isSortOut: false, /* show modal */
              });
    }
        
    //--------------------
    //-- obtiene un numero aleatorio, en un rango determinado
    getRandomInt=(min, max)=> {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    //----------------------------
    
    //---------------------------
    render() {
    
      return (
        <div>
          <ToastContainer />
          
          {/*--- modal---- */}
          <Modal isOpen={this.state.modalInsertar} toggle={this.closeModal} >
            <ModalHeader toggle={this.closeModal} 
              className= { (this.state.form.ope==='n'? 'header-verde':'header-naranja') + ' ' + (this.state.form.ope==='n'? "color:'#45b545'":"color:'#343b43'")  } 
            >
              <span className="modal-title">
              { this.state.form.ope==='n'
                ? "Nuevo"
                : "Editar"
              }
              </span>
              {
                //JSON.stringify( this.state.form )
              }
            </ModalHeader>
  
            <ModalBody style={{background: "#F7F7F7"}}>
                                
              <form  method='POST'>
        
            
                <div className='form-group row'>
                    <label for='id_carre' className='col-lg-3 control-label'><b>Participantes</b></label>
                    <div className='col-lg-9'>
                        
                    <input
                      type='text'
                      name='tam'
                      value={this.state.dataList.length }
                      onChange={this.handleChangeForm}
                      className='form-control'
                      disabled={true}
                    />
      
                    </div>
                </div>
                <div className='form-group row pt-2'>
                    <label for='nombreca' className='col-lg-3 control-label'><b></b></label>
                    <div className='col-lg-9'>

                    { this.state.isSortOut===true ?
                        <NuSpinner
                            color='#e12d6c'
                            size={60}
                        />
                        : ''
                    }
                    
                    <button onClick={this.sortear_click }>Sortear</button>
                    </div>
                </div>
                <div className='form-group row pt-2'>
                    <label className='col-lg-3 control-label'><b>Nombre</b></label>
                    <div className='col-lg-9'>
                        
                    <input
                      type='text'
                      name='nomape_tmp'
                      value={this.state.form.nomape_tmp }
                      onChange={this.handleChangeForm}
                      className='form-control'
                    />
      
                    </div>
                </div>

              
                
              </form>
        
              
            </ModalBody>
            <ModalFooter>
              
              <Button color='secondary' onClick={this.closeModal}>Cancel</Button>
            </ModalFooter>
          </Modal>
        </div>
      );
    }
  }
  
  //------------
  export default ModalSorteo;